import api from '@/lib/axios';

export interface CreateCompanyData {
  name: string;
  slug: string;
  rfc?: string;
  email?: string;
  phone?: string;
  enablePreSales?: boolean;
  ticketHeader?: string;
  ticketFooter?: string;
  legalName?: string;
  taxRegime?: string;
  taxZipCode?: string;
}

export const empresasService = {
  async findAll() {
    const response = await api.get('/companies');
    return response.data;
  },

  async findById(id: string) {
    const response = await api.get(`/companies/${id}`);
    return response.data;
  },

  async create(data: CreateCompanyData) {
    const response = await api.post('/companies', data);
    return response.data;
  },

  async update(id: string, data: Partial<CreateCompanyData>) {
    const response = await api.patch(`/companies/${id}`, data);
    return response.data;
  },

  async deactivate(id: string) {
    const response = await api.delete(`/companies/${id}`);
    return response.data;
  },

  async uploadCsd(id: string, formData: FormData) {
    const response = await api.post(`/companies/${id}/csd`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },
};
